import { useMemo } from "react";
import axios from "axios";

const useAxiosPublic = () => {
  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: "https://admin.zums.edu.bd/api",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, []);

  return axiosInstance;
};

export default useAxiosPublic;
